import { render } from "./EmbedHeaderTodayButton.vue?vue&type=template&id=520d8b71"
import script from "./EmbedHeaderTodayButton.vue?vue&type=script&lang=js"
export * from "./EmbedHeaderTodayButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__